import { render } from "./LegsPricing.vue?vue&type=template&id=0f11bdbb&scoped=true&lang=pug"
import script from "./LegsPricing.vue?vue&type=script&lang=ts"
export * from "./LegsPricing.vue?vue&type=script&lang=ts"

import "./LegsPricing.vue?vue&type=style&index=0&id=0f11bdbb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0f11bdbb"

export default script